export default {
    namespaced: true,
    detection_event: {
      title: "detetion event|detections events",
      event_type: "event type",
      event_created_at: "Event created at",
      provider: "provider",
      data: "data",
      metadata:"metadata",
      media: "media",
      pause: 'Pause',
      play: 'Play',
      playing: 'Playing',
      update: 'Update',
      ms_title: "ms detetion event|ms detections events",
      export_excel: "Export Excel",
      fire_smoke: {
        option: "Fire and smoke report",
        modal_title: "Export fire and smoke report",
        date_range: "Date range",
        export: "Export",
        cancel: "Cancel",
        select_range: "Select a date range",
        export_error: "Error exporting the fire and smoke report",
      },
    },
  };
  